module.exports = __webpack_public_path__ + "static/media/3_r_stupeni_86.88_87.41.25767740.png";